import { useMemo } from 'react'
import { doc } from 'firebase/firestore'
import type { DocumentReference } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useFirestoreDoc } from './useFirestore'
import type { Venue } from '../types'

export function useVenue(venueId: string | undefined) {
  const ref = useMemo(
    () =>
      venueId
        ? (doc(db, 'venues', venueId) as DocumentReference<Venue>)
        : null,
    [venueId],
  )
  const { data: venue, loading, error } = useFirestoreDoc(ref)
  return { venue, loading, error }
}
